import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { ArrowLeft, Printer, Link2, Award, Info } from 'lucide-react';
import { EmptyState, PageSkeleton } from '@/components/dashboard/MetricCard';
import Diploma from '@/components/academy/Diploma';
import { academyApi } from '@/services/academyApi';
import { courseHref } from '@/pages/dashboard/DashboardAcademia';

/* Diploma de un curso de FHC Academy (/dashboard/academia/diploma/:code). Se descarga con «Imprimir → Guardar como PDF». */
export default function DashboardDiploma() {
  const { code } = useParams();
  const [cert, setCert] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    academyApi.certificate(code).then(setCert).catch((e) => setError(e.message));
  }, [code]);

  if (error) {
    return <EmptyState icon={Award} title="No hemos encontrado este diploma" text={error}
      action={<Link to="/dashboard/academia" className="rounded-xl bg-[#c9a84c] px-4 py-2 text-sm font-semibold text-[#0a1628]">Volver a la Academia</Link>} />;
  }
  if (!cert) return <PageSkeleton cards={0} rows={4} />;

  const verifyUrl = `${window.location.origin}/diploma/${cert.code}`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(verifyUrl); toast.success('Enlace de verificación copiado'); } catch { toast(verifyUrl); }
  };

  return (
    <div className="space-y-5" data-testid="dashboard-diploma">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <Link to={courseHref(cert.course_id)} className="inline-flex w-fit items-center gap-1.5 text-sm text-gray-400 hover:text-white"><ArrowLeft size={15} /> Volver a la Academia</Link>
        {!cert.revoked && (
        <div className="flex flex-wrap gap-2">
          <button type="button" onClick={copy} className="inline-flex items-center gap-2 rounded-xl border border-white/10 px-4 py-2.5 text-sm text-white hover:bg-white/[0.05]">
            <Link2 size={15} /> Copiar enlace de verificación
          </button>
          <button type="button" onClick={() => window.print()} data-testid="diploma-print"
            className="inline-flex items-center gap-2 rounded-xl bg-[#c9a84c] px-4 py-2.5 text-sm font-semibold text-[#0a1628] hover:bg-[#d6b75a]">
            <Printer size={15} /> Descargar en PDF
          </button>
        </div>
        )}
      </div>
      {cert.revoked && <p className="rounded-xl border border-red-400/30 bg-red-500/10 px-4 py-3 text-sm text-red-200">Este diploma está anulado.</p>}
      <Diploma cert={cert} verifyUrl={verifyUrl.replace(/^https?:\/\//, '')} />
      {!cert.revoked && (
      <p className="flex items-start gap-2 text-xs text-gray-400 leading-relaxed">
        <Info size={14} className="mt-0.5 flex-shrink-0 text-[#c9a84c]" />
        <span>
          Para guardarlo en PDF pulsa «Descargar en PDF» y, en la ventana de impresión, elige «Guardar como PDF», orientación horizontal y activa «Gráficos de fondo».
          {cert.name_source === 'perfil' && ' El nombre sale de tu perfil porque aún no has completado la verificación de identidad; si no es tu nombre completo, escríbenos y lo corregimos.'}
        </span>
      </p>
      )}
    </div>
  );
}
